import React, { useState, useEffect } from "react";
import api from "../services/api";
import Navbar from "../components/Navbar";

const VoucherHistory = () => {
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUserVouchers();
  }, []);

  const fetchUserVouchers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const res = await api.get("/vouchers/user");
      setVouchers(res.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="bg-gray-50 dark:bg-slate-950 min-h-screen pt-16 sm:pt-32 pb-20 transition-colors duration-500"
      style={{ 
        zoom: "0.8",
        MozTransform: "scale(0.8)",
        MozTransformOrigin: "top center"
      }}
    >
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 mt-2 sm:mt-4 mb-8 sm:mb-12">
        <div className="mb-6 sm:mb-10">
          <h1 className="text-2xl sm:text-4xl font-black text-gray-900 dark:text-white mb-1 sm:mb-2 text-left">
            Kho Voucher Của Bạn
          </h1>
          <p className="text-xs sm:text-sm text-gray-500 dark:text-slate-400 text-left">
            Nơi lưu trữ các mã giảm giá bạn đã săn được!
          </p>
        </div>

        {loading ? (
          <div className="py-20 text-center dark:text-slate-400">Đang tải...</div>
        ) : vouchers.length === 0 ? (
          <div className="bg-white dark:bg-slate-900 rounded-3xl p-20 text-center shadow-sm border border-gray-100 dark:border-slate-800">
            <div className="text-6xl mb-4">🎫</div>
            <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-2">
              Chưa có voucher nào
            </h3>
            <p className="text-gray-500 dark:text-slate-400 mb-8">
              Hãy thử vận may với vòng quay may mắn nhé!
            </p>
            <button
              onClick={() => (window.location.href = "/")}
              className="bg-blue-600 text-white px-8 py-3 rounded-xl font-bold hover:bg-blue-700 transition"
            >
              Quay ngay
            </button>
          </div>
        ) : (
          <div className="grid gap-6">
            {vouchers.map((v) => (
              <div
                key={v._id}
                className="bg-white dark:bg-slate-900 flex flex-col sm:flex-row rounded-3xl overflow-hidden shadow-sm border border-gray-100 dark:border-slate-800 hover:shadow-xl dark:hover:shadow-blue-900/10 transition-all group"
              >
                <div
                  className={`w-full sm:w-32 h-20 sm:h-auto flex flex-row sm:flex-col items-center justify-center text-white p-3 sm:p-4 relative ${
                    v.type === "gift"
                      ? "bg-gradient-to-br from-cyan-500 to-blue-600"
                      : "bg-gradient-to-br from-blue-600 to-purple-600"
                  }`}
                >
                  <span className="text-2xl sm:text-3xl font-black">
                    {v.type === "gift"
                      ? "🎁"
                      : v.type === "percent"
                        ? `${v.value}%`
                        : "OFF"}
                  </span>
                  <div className="ml-3 sm:ml-0 flex flex-col items-center">
                    <span className="text-[10px] uppercase font-bold tracking-widest sm:mt-1 opacity-80 text-center">
                      {v.type === "gift" ? "Gift" : "Discount"}
                    </span>
                  </div>
                  {/* Đường cắt vé - Chỉ hiển thị trên Desktop hoặc điều chỉnh */}
                  <div className="hidden sm:flex absolute top-0 bottom-0 -right-2 w-4 flex-col justify-around">
                    {[...Array(6)].map((_, i) => (
                      <div
                        key={i}
                        className="w-4 h-4 rounded-full bg-gray-50 dark:bg-slate-950"
                      ></div>
                    ))}
                  </div>
                  <div className="sm:hidden absolute left-0 right-0 -bottom-1.5 h-3 flex flex-row justify-around overflow-hidden">
                    {[...Array(15)].map((_, i) => (
                      <div
                        key={i}
                        className="w-3 h-3 rounded-full bg-gray-50 dark:bg-slate-950 flex-shrink-0"
                      ></div>
                    ))}
                  </div>
                </div>
                <div className="flex-1 p-4 sm:p-6 sm:pl-8">
                  <div className="flex justify-between items-start mb-4">
                    <div className="text-left">
                      <h3 className="text-base sm:text-xl font-black text-gray-800 dark:text-white mb-0.5 sm:mb-1">
                        {v.type === "gift" ? v.giftName : v.code}
                      </h3>
                      <p className="text-gray-400 dark:text-slate-500 text-[10px] sm:text-sm">
                        {v.type === "gift"
                          ? "Voucher đổi quà tặng vật phẩm"
                          : v.description || "Dành cho đơn hàng của bạn"}
                      </p>
                    </div>
                    {v.type !== "gift" && (
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(v.code);
                          alert("Đã sao chép mã!");
                        }}
                        className="text-blue-600 dark:text-blue-400 text-sm font-bold hover:underline"
                      >
                        SAO CHÉP
                      </button>
                    )}
                    {v.type === "gift" && (
                      <span className="text-blue-500 dark:text-blue-400 text-[10px] font-black uppercase tracking-tighter border-2 border-blue-500 dark:border-blue-400 px-2 py-0.5 rounded-lg">
                        QUÀ TẶNG
                      </span>
                    )}
                  </div>
                  <div className="flex items-center justify-between mt-auto pt-3 sm:pt-4 border-t border-dashed border-gray-100 dark:border-slate-800">
                    <div className="flex flex-col items-start gap-1">
                      <div className="text-xs text-gray-400 dark:text-slate-500">
                        Hết hạn:{" "}
                        <span className="font-bold">
                          {new Date(v.expiryDate).toLocaleDateString("vi-VN")}
                        </span>
                      </div>
                      {/* Cảnh báo sắp hết hạn (trong vòng 24h) */}
                      {Math.ceil(
                        (new Date(v.expiryDate) - new Date()) /
                          (1000 * 60 * 60 * 24),
                      ) <= 1 && (
                        <div className="text-[10px] font-bold text-orange-600 bg-orange-50 dark:bg-orange-900/20 px-2 py-0.5 rounded-lg animate-pulse">
                          Sắp hết hạn (Còn &lt; 24h)
                        </div>
                      )}
                    </div>
                    <div className="text-xs font-bold text-green-600 bg-green-50 dark:bg-green-900/20 px-3 py-1 rounded-full">
                      Khả dụng
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VoucherHistory;
